// Pure money primitives for the Web Register pricing engine.
// Mirrors Android OrderCreateViewModel rounding behavior. NO React/Redux here.
//
// roundHalfUp mirrors Java String.format("%.2f", x) which rounds HALF_UP.
// truncate2 mirrors truncateToTwoDecimals1 (truncation toward zero).
// NEVER use Number.prototype.toFixed for money math (engine-dependent tie behavior).

export function toNum(v) {
  if (v == null) return 0;
  if (typeof v === "number") return isNaN(v) ? 0 : v;
  const n = parseFloat(String(v).replace(/[$,]/g, ""));
  return isNaN(n) ? 0 : n;
}

export function roundHalfUp(v) {
  const n = toNum(v);
  if (n === 0) return 0;
  const shifted = Math.abs(n) * 100;
  // +1e-9 biases exact-half float representations up, matching Java %.2f HALF_UP.
  const r = Math.round(shifted + 1e-9);
  return (n < 0 ? -1 : 1) * (r / 100);
}

export function truncate2(v) {
  const n = toNum(v);
  return Math.trunc(n * 100) / 100;
}
